import { Icon, useMediaQuery } from '@msaf/core-react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { MAP_NAVIGATION_BREAKPOINT } from '../../../constants'
import { desktopPanelAnimations, mobilePanelAnimations } from './animations'

export interface MapPanelProps {
  isCollapsed?: boolean
  updatePanelState: Function
  markerPanelComponent?: JSX.Element
}

export default function MapPanel({
  isCollapsed,
  updatePanelState,
  markerPanelComponent: MarkerPanelComponent,
  children,
}: React.PropsWithChildren<MapPanelProps>) {
  // Control state of expand/contract button via CSS classes
  const collapseBtnClasses = classNames('c-collapse-btn', {
    'c-collapse-btn--expand': isCollapsed,
  })

  // Conditionally select animation behaviour based on viewport size
  const isDesktop = useMediaQuery(`(min-width: ${MAP_NAVIGATION_BREAKPOINT})`)
  const panelAnimations = isDesktop ? desktopPanelAnimations : mobilePanelAnimations

  return (
    <motion.div
      className='l-map-page__panels-animation-container'
      variants={panelAnimations}
      initial='default'
      animate={isCollapsed ? 'collapsed' : 'default'}
    >
      <div className='c-map-panel'>
        {/* Close panel button (mobile only) */}
        <button onClick={() => updatePanelState(true, false)} className='c-map-panel__close-btn'>
          <Icon icon='close' className='c-map-panel__close-btn-icon' ariaLabel='Close panel' />
        </button>

        {/* Expand/collapse menu items button (tablet up) */}
        <button className={collapseBtnClasses} onClick={() => updatePanelState(!isCollapsed)}>
          <Icon icon='collapse' className='c-collapse-btn__icon' ariaLabel='collapse' />
        </button>

        {/* Children elements should be wrapped in <MapPanelContent> component for consistent padding, heading styles etc */}
        {children}
      </div>

      {/*
        Marker panel (only visible when map marker selected) needs to be output here on desktop for positioning
        (is output as sibling to MapPanel in MapPage component on mobile instead for same reason)
      */}
      {isDesktop && MarkerPanelComponent}
    </motion.div>
  )
}
